import { render, staticRenderFns } from "./System.vue?vue&type=template&id=5224645c&"
import script from "./System.vue?vue&type=script&lang=js&"
export * from "./System.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5224645c')) {
      api.createRecord('5224645c', component.options)
    } else {
      api.reload('5224645c', component.options)
    }
    module.hot.accept("./System.vue?vue&type=template&id=5224645c&", function () {
      api.rerender('5224645c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sysadmin/System.vue"
export default component.exports